import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { NgbActiveModal, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-arbetsorder-virkesorder-warning",
    templateUrl: "./arbetsorder-virkesorder-warning.component.html",
    styleUrls: ["./arbetsorder-virkesorder-warning.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        ButtonComponent
    ]
})
export class ArbetsorderVirkesorderWarningComponent {
    readonly activeModal = inject(NgbActiveModal);

    result = false;

    static open(modalService: NgbModal, callBack: (result: any) => void = null) {
        const options = {
            keyboard: false,
            backdrop: null,
            centered: true,
            windowClass: "hantera-rader-modal-size"
        } as NgbModalOptions;
        const modalRef = modalService.open(this, options);
        if (callBack) {
            modalRef.result.then(r => callBack(r));
        } else {
            modalRef.result.then(r => modalRef.close(r));
        }
    }

    close(shouldOpenBegransingar: boolean) {
        this.activeModal.close(shouldOpenBegransingar);
    }

}
